import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { Router } from '@angular/router';
import { filterUndefined } from '@principle-theorem/shared';
import { PhoneMultiFactorInfo, TotpMultiFactorInfo } from 'firebase/auth';
import { duration } from 'moment-timezone';
import { timer } from 'rxjs';
import { take } from 'rxjs/operators';
import { AuthService } from '../../auth.service';
import {
  IMultifactorVerificationContext,
  MultifactorFactorId,
} from '../multifactor.types';
import { PhoneVerifyComponent } from './phone-verify.component';
import { TotpVerifyComponent } from './totp-verify.component';

@Component({
  selector: 'pt-multifactor-verify-page',
  templateUrl: './multifactor-verify-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatCardModule,
    MatTabsModule,
    MatButtonModule,
    PhoneVerifyComponent,
    TotpVerifyComponent,
  ],
})
export class MultifactorVerifyPageComponent {
  private _router = inject(Router);
  private _changeDetectorRef = inject(ChangeDetectorRef);

  auth = inject(AuthService);
  context: IMultifactorVerificationContext | undefined;
  phoneHints: PhoneMultiFactorInfo[] = [];
  totpHints: TotpMultiFactorInfo[] = [];

  constructor() {
    this.auth.multifactorVerificationRequired$
      .pipe(filterUndefined(), take(1), takeUntilDestroyed())
      .subscribe((context) => {
        this.context = context;
        this.phoneHints = context.hints.filter(
          (hint): hint is PhoneMultiFactorInfo =>
            hint.factorId === MultifactorFactorId.Phone
        );
        this.totpHints = context.hints.filter(
          (hint): hint is TotpMultiFactorInfo =>
            hint.factorId === MultifactorFactorId.Totp
        );
        this._changeDetectorRef.markForCheck();
      });

    timer(duration(5, 'seconds').asMilliseconds())
      .pipe(takeUntilDestroyed())
      .subscribe(() => {
        if (!this.context) {
          void this._router.navigate(['/login']);
        }
      });
  }

  async onVerified(): Promise<void> {
    this.auth.clearMultifactorContext();
    await this._router.navigate(['/']);
  }
}
